import { api } from "../AxiosInstance";
import {
  CreateDriverRequest,
  Driver,
  UpdateDriverRequest,
} from "../interfaces/driver.interface";
import rbacUtils from "../utils/rbacUtils";
import { urlQueryBuilder } from "../utils/urlQueryBuilder";

// Enable mock mode for local testing
const useMocks = false;

const DriverService = {
  getDriversStats: async (options: { signal?: AbortSignal } = {}) => {
    try {
      const response = await api.get("/fed/drivers/driver-stats", options);
      return response.data;
    } catch (error) {
      console.error("Error getDriversStats:", error);
      throw error;
    }
  },

  // RBAC-based getDrivers
  getDriversRBAC: async (
    userProfile: any,
    queryParams: {
      status?: string;
      skip?: number;
      limit?: number;
      transporterIds?: string;
      search?: string;
      available?: boolean;
      signal?: AbortSignal;
    } = {}
  ) => {
    try {
      let baseEndpoint = "/drivers";
      console.log("DriverService.getDriversRBAC userProfile:", userProfile);
      console.log("DriverService.getDriversRBAC queryParams:", queryParams);
      const endpoint = rbacUtils.getRoleBasedEndpoint(
        userProfile,
        baseEndpoint
      );
      console.log("DriverService.getDriversRBAC endpoint:", endpoint);
      const { signal, ...params } = queryParams;
      const queryString = urlQueryBuilder(params);
      const response = await api.get(
        `${endpoint}${queryString ? `?${queryString}` : ""}`,
        { signal }
      );
      if (!response || !response.data) {
        throw new Error("Invalid response from server");
      }
      return response;
    } catch (error) {
      console.error("Error getDriversRBAC:", error);
      throw error;
    }
  },

  // RBAC-based createDriver

  createDriverRBAC: async (
    userProfile: any,
    driverData: CreateDriverRequest
  ): Promise<Driver> => {
    if (useMocks) {
      console.log(
        "[MOCK] createDriverRBAC called with userProfile:",
        userProfile
      );
      console.log(
        "[MOCK] createDriverRBAC called with driverData:",
        driverData
      );
      // Return a fake driver object
      return Promise.resolve({
        id: 999,
        driverName: driverData.driverName,
        driverLicenseNumber: driverData.driverLicenseNumber,
        driverMobileNumber: driverData.driverMobileNumber,
        driverEmail: driverData.driverEmail || "",
        dateOfBirth: driverData.dateOfBirth,
        driverAddress: driverData.driverAddress,
        driverStatus: "Available",
        transporterIdName: { id: 1, uniqueId: "T001", name: "TransOne" },
        currentTruckIdName: { id: 1, name: "Truck A" },
        available: true,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        createdBy: "mock",
        updatedBy: null,
        links: [],
        transporterName: "TransOne",
        transporterUniqueId: "T001",
        truckName: "Truck A",
        truckId: 1,
      });
    }
    try {
      let baseEndpoint = "/driver";
      const endpoint = rbacUtils.getRoleBasedEndpoint(
        userProfile,
        baseEndpoint
      );
      const response = await api.post(endpoint, driverData);
      return response.data;
    } catch (error) {
      console.error("Error creating driver (RBAC):", error);
      throw error;
    }
  },

  // RBAC-based updateDriver

  updateDriverRBAC: async (
    userProfile: any,
    driverData: UpdateDriverRequest
  ): Promise<Driver> => {
    if (useMocks) {
      console.log(
        "[MOCK] updateDriverRBAC called with userProfile:",
        userProfile
      );
      console.log(
        "[MOCK] updateDriverRBAC called with driverData:",
        driverData
      );
      // Return a fake updated driver object
      return Promise.resolve({
        id: driverData.id,
        driverName: driverData.driverName,
        driverLicenseNumber: driverData.driverLicenseNumber,
        driverMobileNumber: driverData.driverMobileNumber,
        driverEmail: driverData.driverEmail || "",
        dateOfBirth: driverData.dateOfBirth,
        driverAddress: driverData.driverAddress,
        driverStatus: "Available",
        transporterIdName: { id: 1, uniqueId: "T001", name: "TransOne" },
        currentTruckIdName: { id: 1, name: "Truck A" },
        available: true,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        createdBy: "mock",
        updatedBy: null,
        links: [],
        transporterName: "TransOne",
        transporterUniqueId: "T001",
        truckName: "Truck A",
        truckId: 1,
      });
    }
    try {
      let baseEndpoint = "/driver";
      const endpoint = rbacUtils.getRoleBasedEndpoint(
        userProfile,
        baseEndpoint
      );
      const response = await api.put(endpoint, driverData);
      return response.data;
    } catch (error) {
      console.error("Error updating driver (RBAC):", error);
      throw error;
    }
  },

  // RBAC-based deleteDriver
  deleteDriverRBAC: async (
    userProfile: any,
    driverId: number
  ): Promise<void> => {
    if (useMocks) {
      console.log(
        "[MOCK] deleteDriverRBAC called with userProfile:",
        userProfile
      );
      console.log("[MOCK] deleteDriverRBAC called with driverId:", driverId);
      return Promise.resolve();
    }
    try {
      let baseEndpoint = "/driver";
      const endpoint = rbacUtils.getRoleBasedEndpoint(
        userProfile,
        baseEndpoint
      );
      await api.delete(`${endpoint}/${driverId}`);
    } catch (error) {
      console.error("Error deleting driver (RBAC):", error);
      throw error;
    }
  },

  // RBAC-based getDrivers
  getDriversNew: async (
    userProfile?: any,
    queryParams: {
      status?: string;
      skip?: number;
      limit?: number;
      transporterIds?: string;
      search?: string;
      available?: boolean;
      signal?: AbortSignal;
    } = {}
  ) => {
    try {
      // let baseEndpoint = "/drivers";
      // console.log("DriverService.getDriversRBAC userProfile:", userProfile);
      // console.log("DriverService.getDriversRBAC queryParams:", queryParams);
      // const endpoint = rbacUtils.getRoleBasedEndpoint(userProfile, baseEndpoint);
      // console.log("DriverService.getDriversRBAC endpoint:", endpoint);
      const { signal, ...params } = queryParams;
      const queryString = urlQueryBuilder(params);
      const response = await api.get(
        `/fed/drivers${queryString ? `?${queryString}` : ""}`,
        { signal }
      );
      if (!response || !response.data) {
        throw new Error("Invalid response from server");
      }
      return response;
    } catch (error) {
      console.error("Error getDriversRBAC:", error);
      throw error;
    }
  },

  // Create new driver
  createDriverNew: async (
    userProfile: any,
    driverData: CreateDriverRequest
  ): Promise<Driver> => {
    try {
      const response = await api.post("/fed/driver", driverData);
      return response.data;
    } catch (error) {
      console.error("Error creating driver:", error);
      throw error;
    }
  },

  // Update existing driver
  updateDriverNew: async (
    userProfile: any,
    driverData: UpdateDriverRequest
  ): Promise<Driver> => {
    try {
      const response = await api.put("/fed/driver", driverData);
      return response.data;
    } catch (error) {
      console.error("Error updating driver:", error);
      throw error;
    }
  },

  // Delete truck
  deleteDriverNew: async (driverId: number): Promise<void> => {
    try {
      await api.delete(`/fed/driver/${driverId}`);
    } catch (error) {
      console.error("Error deleting driver:", error);
      throw error;
    }
  },

  getDrivers: async (
    userProfile: any,
    params?: {
      status?: string;
      skip?: number;
      limit?: number;
      search?: string;
      available?: boolean;
      transporterIds?: string;
    }
  ) => {
    try {
      let baseEndpoint = "/drivers";
      const endpoint = rbacUtils.getRoleBasedEndpoint(
        userProfile,
        baseEndpoint
      );

      console.log(
        "DriverService.getDrivers endpoint:",
        endpoint,
        "params:",
        params
      );
      const response = await api.get(`${endpoint}`, {
        params: { ...params, limit: params?.limit || 50 },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching federation transporters:", error);
      throw error;
    }
  },

  // Unified CRUD using RBAC (userProfile required)
  //   getDrivers: async (
  //     userProfile: any,
  //     params?: {
  //       status?: string;
  //       skip?: number;
  //       limit?: number;
  //       search?: string;
  //       available?: boolean;
  //       transporterIds?: string;
  //     }
  //   ) => {
  //     // Determine base endpoint by role
  //     let baseEndpoint = "/drivers";
  //     // For client, the endpoint is /client/drivers
  //     const roleName = userProfile?.role?.name;
  //     if (roleName === "ROLE_CLIENT_ADMIN") baseEndpoint = "/client/drivers";
  //     else if (roleName === "ROLE_FEDERATION_ADMIN") baseEndpoint = "/drivers";
  //     else if (roleName === "ROLE_TRANSPORTER_ADMIN")
  //       baseEndpoint = "/transporter/drivers";
  //     const endpoint = rbacUtils.getRoleBasedEndpoint(userProfile, baseEndpoint);
  //     return api.get(`${endpoint}`, { params: { ...params, limit: 50 } });
  //   },

  getDriverById: async (
    userProfile: any,
    driverId: number,
    transporterId?: number
  ) => {
    let baseEndpoint = "/driver";
    const roleName = userProfile?.role?.name;
    if (roleName === "ROLE_CLIENT_ADMIN") baseEndpoint = "/enterprise/driver";
    else if (roleName === "ROLE_FEDERATION_ADMIN") baseEndpoint = "/fed/driver";
    else if (roleName === "ROLE_TRANSPORTER_ADMIN")
      baseEndpoint = "/transporter/driver";
    const endpoint = rbacUtils.getRoleBasedEndpoint(userProfile, baseEndpoint);
    // transporterId is required for fed/client, not for transporter
    const params: any = { driverId };
    if (transporterId) params.transporterId = transporterId;
    return api.get(`/api/v2${endpoint}`, { params });
  },

  createDriver: async (userProfile: any, data: any) => {
    let baseEndpoint = "/driver";
    const roleName = userProfile?.role?.name;
    if (roleName === "ROLE_CLIENT_ADMIN") baseEndpoint = "/enterprise/driver";
    else if (roleName === "ROLE_FEDERATION_ADMIN") baseEndpoint = "/driver";
    else if (roleName === "ROLE_TRANSPORTER_ADMIN")
      baseEndpoint = "/transporter/driver";
    const endpoint = rbacUtils.getRoleBasedEndpoint(userProfile, baseEndpoint);
    // Only send required fields
    const payload = {
      driverName: data.driverName,
      transporterId: data.transporterId ?? null,
      driverLicenseNumber: data.driverLicenseNumber,
      driverMobileNumber: data.driverMobileNumber,
      driverEmail: data.driverEmail || undefined,
      dateOfBirth: data.dateOfBirth, // expects YYYY-MM-DD string
      driverAddress: data.driverAddress,
      truckId: data.truckId ?? null,
    };
    return api.post(`${endpoint}`, payload);
  },

  updateDriver: async (userProfile: any, data: any) => {
    let baseEndpoint = "/driver";
    const roleName = userProfile?.role?.name;
    if (roleName === "ROLE_CLIENT_ADMIN") baseEndpoint = "/enterprise/driver";
    else if (roleName === "ROLE_FEDERATION_ADMIN") baseEndpoint = "/fed/driver";
    else if (roleName === "ROLE_TRANSPORTER_ADMIN")
      baseEndpoint = "/transporter/driver";
    const endpoint = rbacUtils.getRoleBasedEndpoint(userProfile, baseEndpoint);
    return api.put(`/api/v2${endpoint}`, data);
  },

  deleteDriver: async (
    userProfile: any,
    driverId: number,
    transporterId?: number
  ) => {
    let baseEndpoint = "/driver";
    const roleName = userProfile?.role?.name;
    if (roleName === "ROLE_CLIENT_ADMIN") baseEndpoint = "/enterprise/driver";
    else if (roleName === "ROLE_FEDERATION_ADMIN") baseEndpoint = "/fed/driver";
    else if (roleName === "ROLE_TRANSPORTER_ADMIN")
      baseEndpoint = "/transporter/driver";
    const endpoint = rbacUtils.getRoleBasedEndpoint(userProfile, baseEndpoint);
    const params: any = { driverId };
    if (transporterId) params.transporterId = transporterId;
    return api.delete(`/api/v2${endpoint}`, { params });
  },
};

export default DriverService;
